import { render, staticRenderFns } from "./ByJsonBlock.vue?vue&type=template&id=e246d28c&scoped=true&"
import script from "./ByJsonBlock.vue?vue&type=script&lang=js&"
export * from "./ByJsonBlock.vue?vue&type=script&lang=js&"
import style0 from "./ByJsonBlock.vue?vue&type=style&index=0&id=e246d28c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e246d28c",
  null
  
)

export default component.exports